/** "Share": the owner edits who else may see and review the queue, by email. */

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/overlay";
import { errorText } from "@/components/ui/states";
import { useUiStore } from "@/stores/ui-store";
import { EmailsInput } from "./emails-input";
import { useUpdateQueue } from "./hooks";
import type { QueueDetail } from "./types";

export function ShareDialog({ queue, onClose }: { queue: QueueDetail; onClose: () => void }) {
  const [reviewers, setReviewers] = useState(queue.reviewers);
  const update = useUpdateQueue(queue.id);
  const notify = useUiStore((s) => s.notify);
  const save = () =>
    update.mutate(
      { reviewers },
      {
        onSuccess: () => (notify(`Shared ${queue.name}.`), onClose()),
        onError: (e) => notify(errorText(e, "Could not share the queue."), "error"),
      },
    );
  return (
    <Dialog
      title={`Share ${queue.name}`}
      subtitle="People you add see this queue under Annotate and can review its items."
      onClose={onClose}
      width={520}
      footer={
        <>
          <span className="flex-1" />
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" disabled={update.isPending} onClick={save}>
            Save
          </Button>
        </>
      }
    >
      <EmailsInput label="Reviewers" value={reviewers} onChange={setReviewers} />
    </Dialog>
  );
}
